var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-hospital"},[_c('h1',[_vm._v("Add Hospital")]),_c('AddHospital',{attrs:{"customer":2},on:{"submit":_vm.create}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }